// extracted by mini-css-extract-plugin
export default {"holder":"shop_holder__R+EMe"};